import React, { useEffect, useState } from 'react';
import './Home.css';
import { DoubleRightOutlined,LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';

export default function HomeCategory() {
  const [mainCategories, setMainCategories] = useState([])
  const [subCategories, setSubCategories] = useState([])
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(true);
  
  const [mallList1, setMallList1] = useState([])
  const [mallList2, setMallList2] = useState([])
  const [mallList3, setMallList3] = useState([])
  const [mallList4, setMallList4] = useState([])  
  const [mallList5, setMallList5] = useState([]) 
  const [mallList6, setMallList6] = useState([])   

  const [homeMall, setHomeMall] = useState([])

  useEffect(() => {

    let res;
    const cachedData = localStorage.getItem("categories");
    // 如果有缓存数据，直接使用
    if (cachedData) {
        res = JSON.parse(cachedData);
    } else {
        // 从远程获取数据
        axios.get("https://api.360ep.cn/api/category/?type=sep").then(
          ret => {
             // 将获取到的数据存储到localStorage中
             localStorage.setItem("categories", JSON.stringify(ret.data));
             res = ret.data;
          }
        )
    }
    
    let menuItems = [];
    let subMenuItems = [];

    res.data.forEach(item => {
      let subMenu = [];

      menuItems.push({
        label: item.catname,
        key: "/#/market/" + item.catid,
        catid: item.catid
      });

      item.children.forEach(subItem => {
        subMenu.push({
          label: subItem.catname,
          key: "/#/market/" + subItem.catid,
          catid: subItem.catid
        });
      });

      subMenuItems.push(subMenu);
    });
    setMainCategories(menuItems);
    setSubCategories(subMenuItems);
    setLoading(false);
    
  }, []);

  useEffect(() => {
    axios.get("https://api.360ep.cn/api/mall?type=home").then(res => {
      let mallList = [];
      Object.entries(res.data.data).forEach(([index, item]) => {
        item.forEach(subItem => {
          mallList.push({
            appid: index,
            itemid: subItem.Itemid,
            title: subItem.Title,
            price: subItem.Price,
            thumb: subItem.Thumb,
            unit: subItem.Unit,
          });
        });
      });
      setHomeMall(mallList);   
      setMallList1(mallList.filter((mall) => mall.appid === '48741'))
      setMallList2(mallList.filter((mall) => mall.appid === '48847'))
      setMallList3(mallList.filter((mall) => mall.appid === '48895'))
      setMallList4(mallList.filter((mall) => mall.appid === '48922'))
      setMallList5(mallList.filter((mall) => mall.appid === '48956'))
      setMallList6(mallList.filter((mall) => mall.appid === '48998'))
      setLoading2(false);
    });
  }, [])

  function handleClick(index,item) {        
    switch(index) {
      case 1:
        setMallList1(homeMall.filter((mall) => mall.appid === item.toString()))
        break;
      case 2:
        setMallList2(homeMall.filter((mall) => mall.appid === item.toString()))
        break;
      case 3:
        setMallList3(homeMall.filter((mall) => mall.appid === item.toString()))
        break;
      case 4:
        setMallList4(homeMall.filter((mall) => mall.appid === item.toString()))
        break;
      case 5:
        setMallList5(homeMall.filter((mall) => mall.appid === item.toString()))
        break;
      case 6:
        setMallList6(homeMall.filter((mall) => mall.appid === item.toString()))
        break;
      default:
        console.log('error item' + item)
    }      
  }

  if (loading || loading2) {
    return <div><LoadingOutlined /></div>;
  }

  return (
    <div className="home-content">
        <div className='each-content'>
          <div style={{ width: "200px" }}>
            <img src="img/u960.jpg" alt="" />
            <div className="content-title">
              <h4 className='content-title-t'>{mainCategories[0].label}</h4>
              <a href={mainCategories[0].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link'>
              <div className='link-title'>{subCategories[0][0].label}</div>
              <div className='link-title'>{subCategories[0][1].label}</div>
              <div className='link-title'>{subCategories[0][2].label}</div>
              <div className='link-title'><a href={subCategories[0][0].key} target='_blank' rel="noopener noreferrer"><img src="img/u944.png" alt="" /></a></div>
              <div className='link-title'><a href={subCategories[0][1].key} target='_blank' rel="noopener noreferrer"><img src="img/u946.png" alt="" /></a></div>
              <div className='link-title'><a href={subCategories[0][2].key} target='_blank' rel="noopener noreferrer"><img src="img/u948.png" alt="" /></a></div>
            </div>
            <div className="gray-line"></div>
            <div className='content-link'>
              {
                subCategories[0].slice(3,19).map((item, index) => {
                  return (
                    <div className='link-title-sub' key={index}><a href={item.key} target='_blank' rel="noopener noreferrer">{item.label}</a></div>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className='each-content'>
          <div style={{ width: "200px" }}>
            <img src="img/u44.jpg" alt="" />
            <div className="content-title">
              <h4 className='content-title-t'>{mainCategories[0].label}</h4>
              <a href={mainCategories[0].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link'>
              <div className='link-title'>{subCategories[1][0].label}</div>
              <div className='link-title'>{subCategories[1][1].label}</div>
              <div className='link-title'>{subCategories[1][2].label}</div>
              <div className='link-title'><a href={subCategories[1][0].key} target='_blank' rel="noopener noreferrer"><img src="img/u28.png" alt="" /></a></div>
              <div className='link-title'><a href={subCategories[1][1].key} target='_blank' rel="noopener noreferrer"><img src="img/u30.png" alt="" /></a></div>
              <div className='link-title'><a href={subCategories[1][2].key} target='_blank' rel="noopener noreferrer"><img src="img/u32.png" alt="" /></a></div>
            </div>
            <div className="gray-line"></div>
            <div className='content-link'>
              {
                subCategories[1].slice(3,19).map((item, index) => {
                  return (
                    <div className='link-title-sub' key={index}><a href={item.key} target='_blank' rel="noopener noreferrer">{item.label}</a></div>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className='each-content-2'>
          <div style={{ width: "200px" }}>
            <img src="img/u62.jpg" alt="" />
            <div className="content-title-2">
              <h4 className='content-title-t'>{mainCategories[2].label}</h4>
              <a href={mainCategories[2].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link-2'>
              <div className='content-link-sub1'>
                {
                  subCategories[2].slice(0, 5).map((item, index) => {
                    return (
                      <div className='content-link-item' key={index} onClick={() => handleClick(1,item.catid)}>{item.label}</div>
                    )
                  })
                }
              </div>
              <div style={{ textAlign: "left" }}><a href={mainCategories[2].key} className='content-title-a'><DoubleRightOutlined /></a></div>
            </div>
            <div className="home-mall-list">
                {
                    mallList1.map((item,index)=>{
                      let url = "https://www.360ep.cn/mall/show.php?itemid="+item.itemid;
                      return (
                      <div className='mall-item' key={index}>
                        <div className='mall-img'>
                          <img src={item.thumb} alt={item.title} style={{width:"140px",height:"140px"}} />
                        </div>
                        <div className='mall-title'>
                          <a href={url} target='_blank' rel="noopener noreferrer">{item.title}</a>
                        </div>
                          <div className='mall-price'>
                          ￥<span style={{fontWeight:"bold"}}>{item.price}</span>/{item.unit}
                          </div>
                      </div>
                      )
                    })                    
                }                
            </div>          
          </div>
        </div>
        <div className='each-content-2'>
          <div style={{ width: "200px" }}>
            <img src="img/u356.jpg" alt="" />
            <div className="content-title-2">
              <h4 className='content-title-t'>{mainCategories[3].label}</h4>
              <a href={mainCategories[3].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link-2'>
              <div className='content-link-sub1'>
                {
                  subCategories[3].slice(0, 5).map((item, index) => {
                    return (
                      <div className='content-link-item' key={index} onClick={() => handleClick(2,item.catid)}>{item.label}</div>
                    )
                  })
                }
              </div>
              <div style={{ textAlign: "left",lineHeight:"20px",height:"20px" }}><a href={mainCategories[3].key} className='content-title-a'><DoubleRightOutlined /></a></div>
            </div>
            <div className="home-mall-list">
                {
                    mallList2.map((item,index)=>{
                      let url = "https://www.360ep.cn/mall/show.php?itemid="+item.itemid;
                      return (
                      <div className='mall-item' key={index}>
                        <div className='mall-img'>
                          <img src={item.thumb} alt={item.title} style={{width:"140px",height:"140px"}} />
                        </div>
                        <div className='mall-title'>
                          <a href={url} target='_blank' rel="noopener noreferrer">{item.title}</a>
                        </div>
                          <div className='mall-price'>
                          ￥<span style={{fontWeight:"bold"}}>{item.price}</span>/{item.unit}
                          </div>
                      </div>
                      )
                    })                    
                }                
            </div>            
          </div>
        </div>
        <div className='each-content-2'>
          <div style={{ width: "200px" }}>
            <img src="img/u304.jpg" alt="" />
            <div className="content-title-2">
              <h4 className='content-title-t'>{mainCategories[4].label}</h4>
              <a href={mainCategories[4].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link-2'>
              <div className='content-link-sub1'>
                {
                  subCategories[4].slice(0, 5).map((item, index) => {
                    return (
                      <div className='content-link-item' key={index} onClick={() => handleClick(3,item.catid)}>{item.label}</div>
                    )
                  })
                }
              </div>
              <div style={{ textAlign: "left",lineHeight:"20px",height:"20px" }}><a href={mainCategories[3].key} className='content-title-a'><DoubleRightOutlined /></a></div>
            </div>
            <div className="home-mall-list">
                {
                    mallList3.map((item,index)=>{
                      let url = "https://www.360ep.cn/mall/show.php?itemid="+item.itemid;
                      return (
                      <div className='mall-item' key={index}>
                        <div className='mall-img'>
                          <img src={item.thumb} alt={item.title} style={{width:"140px",height:"140px"}} />
                        </div>
                        <div className='mall-title'>
                          <a href={url} target='_blank' rel="noopener noreferrer">{item.title}</a>
                        </div>
                          <div className='mall-price'>
                          ￥<span style={{fontWeight:"bold"}}>{item.price}</span>/{item.unit}
                          </div>
                      </div>
                      )
                    })                    
                }                
            </div>            
          </div>
        </div>
        <div className='each-content-2'>
          <div style={{ width: "200px" }}>
            <img src="img/u178.jpg" alt="" />
            <div className="content-title-2">
              <h4 className='content-title-t'>{mainCategories[5].label}</h4>
              <a href={mainCategories[5].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link-2'>
              <div className='content-link-sub1'>
                {
                  subCategories[5].slice(0, 5).map((item, index) => {
                    return (
                      <div className='content-link-item' key={index} onClick={() => handleClick(4,item.catid)}>{item.label}</div>
                    )
                  })
                }
              </div>
              <div style={{ textAlign: "left",lineHeight:"20px",height:"20px" }}><a href={mainCategories[3].key} className='content-title-a'><DoubleRightOutlined /></a></div>
            </div>
            <div className="home-mall-list">
                {
                    mallList4.map((item,index)=>{
                      let url = "https://www.360ep.cn/mall/show.php?itemid="+item.itemid;
                      return (
                      <div className='mall-item' key={index}>
                        <div className='mall-img'>
                          <img src={item.thumb} alt={item.title} style={{width:"140px",height:"140px"}} />
                        </div>
                        <div className='mall-title'>
                          <a href={url} target='_blank' rel="noopener noreferrer">{item.title}</a>
                        </div>
                          <div className='mall-price'>
                          ￥<span style={{fontWeight:"bold"}}>{item.price}</span>/{item.unit}
                          </div>
                      </div>
                      )
                    })                    
                }                
            </div>            
          </div>
        </div>
        <div className='each-content-2'>
          <div style={{ width: "200px" }}>
            <img src="img/u230.jpg" alt="" />
            <div className="content-title-2">
              <h4 className='content-title-t'>{mainCategories[6].label}</h4>
              <a href={mainCategories[6].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link-2'>
              <div className='content-link-sub1'>
                {
                  subCategories[6].slice(0, 5).map((item, index) => {
                    return (
                      <div className='content-link-item' key={index} onClick={() => handleClick(5,item.catid)}>{item.label}</div>
                    )
                  })
                }
              </div>
              <div style={{ textAlign: "left",lineHeight:"20px",height:"20px" }}><a href={mainCategories[3].key} className='content-title-a'><DoubleRightOutlined /></a></div>
            </div>
            <div className="home-mall-list">
                {
                    mallList5.map((item,index)=>{
                      let url = "https://www.360ep.cn/mall/show.php?itemid="+item.itemid;
                      return (
                      <div className='mall-item' key={index}>
                        <div className='mall-img'>
                          <img src={item.thumb} alt={item.title} style={{width:"140px",height:"140px"}} />
                        </div>
                        <div className='mall-title'>
                          <a href={url} target='_blank' rel="noopener noreferrer">{item.title}</a>
                        </div>
                          <div className='mall-price'>
                          ￥<span style={{fontWeight:"bold"}}>{item.price}</span>/{item.unit}
                          </div>
                      </div>
                      )
                    })                    
                }                
            </div>            
          </div>
        </div>
        <div className='each-content-2'>
          <div style={{ width: "200px" }}>
            <img src="img/u114.jpg" alt="" />
            <div className="content-title-2">
              <h4 className='content-title-t'>{mainCategories[7].label}</h4>
              <a href={mainCategories[7].key} className='content-title-a'>更多&gt;&gt;</a>
            </div>
          </div>
          <div className='content-right'>
            <div className='content-link-2'>
              <div className='content-link-sub1'>
                {
                  subCategories[7].slice(0, 5).map((item, index) => {
                    return (
                      <div className='content-link-item' key={index} onClick={() => handleClick(6,item.catid)}>{item.label}</div>
                    )
                  })
                }
              </div>
              <div style={{ textAlign: "left",lineHeight:"20px",height:"20px" }}><a href={mainCategories[3].key} className='content-title-a'><DoubleRightOutlined /></a></div>
            </div>
            <div className="home-mall-list">
                {
                    mallList6.map((item,index)=>{
                      let url = "https://www.360ep.cn/mall/show.php?itemid="+item.itemid;
                      return (
                      <div className='mall-item' key={index}>
                        <div className='mall-img'>
                          <img src={item.thumb} alt={item.title} style={{width:"140px",height:"140px"}} />
                        </div>
                        <div className='mall-title'>
                          <a href={url} target='_blank' rel="noopener noreferrer">{item.title}</a>
                        </div>
                          <div className='mall-price'>
                          ￥<span style={{fontWeight:"bold"}}>{item.price}</span>/{item.unit}
                          </div>
                      </div>
                      )
                    })                    
                }                
            </div>            
          </div>
        </div>
      </div>
  )
}
